import { FC, useContext } from "react";
import FormFieldsContainer from "../../../../components/ui/FormFieldsContainer";
import { Form, ModalDialog } from "@rothoblaas/design-system";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../../../context/notificationContext";
import useI18n from "../../../../hooks/useTranslations";
import {
  SubstructureFamily,
  UpdateSubstructureFamilyBody,
} from "../../../../http/deckDesigner/types/substructureFamilies";
import useDeckSubstructureFamiliesApi from "../../../../http/deckDesigner/useSubstructureFamilies";
import TranslatableTextField from "../../../../components/ui/TranslatableTextField";

interface SubstructureFamilyFormBody {
  name: string | null;
  nameIt: string | null;
  nameDe: string | null;
  nameEs: string | null;
  nameFr: string | null;
}

interface SubstructureFamilyFormProps {
  substructureFamily: SubstructureFamily;
  onClose: () => void;
}

const SubstructureFamilyForm: FC<SubstructureFamilyFormProps> = ({ substructureFamily, onClose }) => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const substructureFamiliesApi = useDeckSubstructureFamiliesApi();

  const defaultValues: SubstructureFamilyFormBody = {
    name: substructureFamily.name ?? null,
    nameIt: substructureFamily.nameIt ?? null,
    nameDe: substructureFamily.nameDe ?? null,
    nameEs: substructureFamily.nameEs ?? null,
    nameFr: substructureFamily.nameFr ?? null,
  };

  const onSubmit = () => async (formData: SubstructureFamilyFormBody) => {
    const body: UpdateSubstructureFamilyBody = {
      name: formData.name ?? "",
      nameIt: formData.nameIt || null,
      nameDe: formData.nameDe || null,
      nameEs: formData.nameEs || null,
      nameFr: formData.nameFr || null,
    };

    try {
      await substructureFamiliesApi.updateDeckSubstructureFamily(substructureFamily.code, body);
      dispatch(showSuccessNotification(i18n.translation));
      onClose();
    } catch (err) {
      dispatch(showErrorNotification(i18n, err));
    }
  };

  return (
    <ModalDialog
      onClose={onClose}
      title={`${i18n.translation.common.edit} ${i18n.translation.deckDesignerModule.substructureFamilies.singular}`}
    >
      <Form<SubstructureFamilyFormBody>
        submitText={i18n.translation.common.save}
        onSubmit={onSubmit}
        defaultValues={defaultValues}
      >
        {(form) => (
          <FormFieldsContainer fullWidth>
            <TranslatableTextField form={form} />
          </FormFieldsContainer>
        )}
      </Form>
    </ModalDialog>
  );
};

export default SubstructureFamilyForm;
